var SetHeaderLinkIndex = (links, prefix = '') => {
    for(let i = 1; i <= links.length; i++) {
        links[i-1].index = prefix + i
        if(links[i-1].children) {
            SetHeaderLinkIndex(links[i-1].children, prefix + i + '-')
        }
    }
}
export default SetHeaderLinkIndex